// Generated by src/localization/generateCatalogs.cjs. Do not edit.
export const loadingMessages = {
  "en": "Preparing the start line…",
  "ca": "Preparant la línia de sortida…",
  "es": "Preparando la línea de salida…",
  "fr": "Préparation de la ligne de départ…",
  "de": "Startlinie wird vorbereitet…",
  "pt-BR": "Preparando a linha de largada…",
  "it": "Preparazione della linea di partenza…",
  "nl": "De startlijn wordt voorbereid…"
};
